import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { TemHarcamaService } from '../ctl-tem-harcama.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: TemHarcamaService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([]);
            const filterArr = [];
            if(this.service.period) filterArr.push(['Donem', '=', this.service.period]);
            if(this.service.kurumsalKod) filterArr.push(['KurumsalKod', '=', this.service.kurumsalKod]);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }

}
